import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingRequestToResponseContent } from '../../../../hooks/useVpsHostingRequestToResponseContent';
import './RequestToResponse.css';

const RequestToResponse = () => {
  const { content, isLoading } = useVpsHostingRequestToResponseContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, steps } = content;

  return (
    <section className="vps-hosting-request-to-response">
      <div className="vps-hosting-request-to-response__inner">
        <Reveal>
          <h2 className="vps-hosting-request-to-response__title">{title}</h2>
        </Reveal>

        <div className="vps-hosting-request-to-response__grid">
          {steps.map(({ number, title: stepTitle, text }, index) => (
            <Reveal key={stepTitle} delay={index * 70}>
              <article className="vps-hosting-request-to-response__item">
                <p className="vps-hosting-request-to-response__number">{number}</p>
                <h3 className="vps-hosting-request-to-response__item-title">{stepTitle}</h3>
                <p className="vps-hosting-request-to-response__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RequestToResponse;
